import { ActiveFilterOption, YearOption } from "./types";

export const ACTIVE_OPTIONS: ActiveFilterOption[] = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const getDefaultYearOptions = (): YearOption[] => [
  {
    label: new Date().getFullYear().toString(),
    value: new Date().getFullYear(),
  },
];

export const DEFAULT_FILTERS = {
  activeOnly: ACTIVE_OPTIONS[0],
  yearSelected: getDefaultYearOptions()[0],
};
